import React, { Fragment } from "react";
// import { Footerdark, PageLayout } from "../../../Constant";
import InvoiceTable from "./InvoiceTable";
import { Footerdark,PageLayout } from "../../../Constant";

const Invoicelist = () => {
    return (
        <Fragment>
            <InvoiceTable mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default Invoicelist;